import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch } from '../store';

interface PipelineState {
  pid: string;
  isRunning: boolean;
  newResult: boolean;
  rid: string;
  error: boolean;
}

const initialState: PipelineState = {
  pid: "",
  isRunning: false,
  newResult: false,
  rid: "",
  error: false,
};

const pipelineSlice = createSlice({
  name: 'pipeline',
  initialState,
  reducers: {
    setNewResult(state, action: PayloadAction<boolean>) {
      state.newResult = action.payload;
    },
    setIsRunning(state, action: PayloadAction<boolean>) {
      state.isRunning = action.payload;
    },
    setPid(state, action: PayloadAction<string>) {
      state.pid = action.payload;
    },
    setRid(state, action: PayloadAction<string>) {
      state.rid = action.payload;
    },
    setError(state, action: PayloadAction<boolean>) {
      state.error = action.payload;
    },
    clearPipeline(state, action: PayloadAction<void>) {
      state.pid = "";
      state.rid = "";
      state.newResult = false;
      state.isRunning = false;
      state.error = false;
    }
  },
});

export const { setNewResult, setIsRunning, setPid, setError, clearPipeline } = pipelineSlice.actions;
export default pipelineSlice.reducer;